<template>
  <div class="relative w-full">
    <c-date-picker
      class="signup-date-picker"
      :value="value"
      :placeholder="placeholder"
      :max="max"
      :month-translations="monthTranslations"
      @update:value="(value) => $emit('update:value', value)"
    />
    <c-icon
      name="CalendarTodayRound"
      size="20px"
      class="absolute right-3.5 top-[14px] text-muted pointer-events-none"
    />
  </div>
</template>

<script>
import CDatePicker from "../../../core-ui/src/components/CDatePicker.vue";
import CIcon from "../../../core-ui/src/components/CIcon.vue";

// Wheel date picker with an input styled like the rest of the signup fields
export default {
  name: "SignupDatePicker",
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    max: {
      type: String,
      default: "",
    },
  },
  emits: ["update:value"],
  computed: {
    monthTranslations() {
      return {
        1: this.$t("january"),
        2: this.$t("february"),
        3: this.$t("march"),
        4: this.$t("april"),
        5: this.$t("may"),
        6: this.$t("june"),
        7: this.$t("july"),
        8: this.$t("august"),
        9: this.$t("september"),
        10: this.$t("october"),
        11: this.$t("november"),
        12: this.$t("december"),
      };
    },
  },
  components: {
    CDatePicker,
    CIcon,
  },
};
</script>

<style scoped>
.signup-date-picker {
  height: 48px;
  border: 1.5px solid var(--lineColor) !important;
  border-radius: 12px !important;
  background-color: var(--fieldColor);
}

.n-form-item-blank--error .signup-date-picker {
  border-color: #db3d55 !important;
}

.signup-date-picker :deep(input[type="text"]) {
  display: block;
  height: 100%;
  padding: 0 44px 0 14px !important;
  border-radius: 12px;
  background-color: transparent;
  color: var(--secondaryColor);
  font-size: 15px;
  outline: none;
  cursor: pointer;
}

.signup-date-picker :deep(input[type="text"]::placeholder) {
  color: var(--mutedColor) !important;
  opacity: 0.75;
}
</style>
